import { useConfig } from "../../../contexts/ConfigContext"
import React, { useEffect, useState } from "react"
import { Button, message, Select, TableColumnsType, Tag } from "antd"
import TableView from "../TableView"
import useAuth from "../../../hooks/useAuth"
import { useCompany } from "../../../contexts/CompanyContext"
import { useCashRegisterFetch, usePosFetch } from "../../../hooks/useSale"
import { TPos, usePos } from "../../../contexts/PosContext"
import { useCashRegister } from "../../../contexts/CashRegisterContext"
import CashRegisterModal from "../../modals/CashRegisterModal"

function ViewCashRegisterList(){
  const { config } = useConfig()
  const { cashRegister, updateCashRegister } = useCashRegister()
  const { pos, updatePos } = usePos()
  const { company } = useCompany()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  
  const { tokenData } = useAuth.useToken('authCsrfToken', config.session, config.key)
  
  // Load POS list
  const { data: posData } = usePosFetch(tokenData, {
    all: true,
    company: company.current.uid,
  },company.current.id)

  // Select first POS if none selected
  const uidPos = pos.currentSelected?.uid ? pos.currentSelected.uid : posData?.pos?.length ? posData.pos[0].uid : ""
  
  const { data: registerData } = useCashRegisterFetch(tokenData, {
    company: company.current.uid,
    module: config.module,
    all: true,
    uidPos: uidPos
  })

  useEffect(() => {
    if(registerData?.cashRegisterList){
      updateCashRegister({list: registerData.cashRegisterList})
    }
    if(posData?.pos?.length){
      const currentSelected = pos.currentSelected?.uid ? pos.currentSelected : posData.pos[0]
      updatePos({list: posData.pos, currentSelected})
    }
    if(registerData || posData){
      setSkeleton(false)
    }
  }, [registerData, posData])

  let title = 'Cajas para ' + (pos.currentSelected?.name || "Punto de venta")
  let emptyMessage = 'Aun no has agregado cajas en este PDV'

  const handleClick = (data:any) => {
    updateCashRegister({showModal: true, current: data})
  }

  const tableColumns: TableColumnsType = [
    { title: "#", dataIndex: "register", width: 50 },
    { title: "Nombre", dataIndex: "name", ellipsis: true },
    { title: "ID", dataIndex: "alias", ellipsis: true },
    { title: "Estado", dataIndex: "is_active", render: (active) => active ? <Tag color="green">Activa</Tag> : <Tag color="red">Inactiva</Tag> },
    { title: "Creado", dataIndex: "created_at", render: (text) => new Date(text).toLocaleString() },
  ]

  const dataTable = cashRegister?.list?.map((el, i) => {
    return {
      ...el,
      register: i + 1,
      key: i
    }
  })

  const handleButtonClick = () => {
    if(pos.list.length === 0){
      message.error('Debe registrar antes un punto de venta')
      return
    }
    updateCashRegister({showModal: true, current: undefined})
  }

  const handleSelect = async (option:string) => {
    setSpinning(true)
    const selectedPos = pos.list.find(el => el.uid === option) as TPos
    updatePos({currentSelected: selectedPos})
    // SWR will revalidate automatically due to key change if we setup correctly, otherwise we trigger it.
    // In this manual impl, we might need to manually trigger if SWR key depends on uidPos variable which updates on render.
    // However, since we used SWR with key including uidPos, it should auto-fetch.
    setSpinning(false)
  }

  const footerElement = () => <Button type="primary" onClick={handleButtonClick} htmlType="button">Crear Caja</Button>
  
  const headerElement = () => <Select onSelect={handleSelect} value={pos.currentSelected?.uid} style={{width:"100%"}}>
    {pos.list.map(el => <Select.Option key={el.uid} value={el.uid}>{el.name}</Select.Option>)}
  </Select>

  return (
    <TableView
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      headerElement={headerElement}
      modal={CashRegisterModal}
      footerElement={footerElement}
      onRow={(data:any) => {return{onClick:()=>handleClick(data), style:{cursor:"pointer"}}}}
      emptyMessage={emptyMessage}>
    </TableView>
  )
}

export default ViewCashRegisterList
